import React, { useState } from 'react';
import PropTypes from 'prop-types';
import {
  Row,
  Col,
  FormGroup,
  Label,
  Input,
} from 'reactstrap';
import Api from '../../../../../services/Api';
import Button from '../../../../atoms/Button/Button';
import CharacteristicsTypeSelector from '../../../../atoms/CharacteristicsTypeSelector/CharacteristicsTypeSelector';
import Icon from '../../../../atoms/Icon/Icon';
import './CreateCharacteristicModal.scss';

const CreateCharacteristicModal = ({
  onItemCreated,
  cityId,
  dynastyId,
}) => {
  const [typeId, setTypeId] = useState(undefined);
  const [name, setName] = useState(undefined);
  const [codeSuffix, setCodeSuffix] = useState(undefined);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(undefined);
  const saveComponent = () => {
    if (!typeId) {
      setError('Characteristic type is required');
      return;
    }
    if (!name) {
      setError('Characteristic name is required');
      return;
    }
    setLoading(true);
    Api.post('instances/building-characteristics', {
      name,
      code_suffix: codeSuffix,
      dynasty_id: dynastyId,
      city_id: cityId,
      characteristic_type_id: typeId,
    }).then((response) => {
      setLoading(false);
      onItemCreated(response.data);
    });
  };
  return (
    <Row>
      <Col md={12}>
        <FormGroup>
          <Label>Type</Label>
          <CharacteristicsTypeSelector
            onChanged={(e) => {
              setTypeId(e.value.id);
              setCodeSuffix(e.value.code.slice(0, 2));
            }}
            isMulti={false}
          />
        </FormGroup>
      </Col>
      <Col md={12}>
        <FormGroup>
          <Label>Name</Label>
          <Input type="text" onChange={e => setName(e.target.value)} value={name} />
        </FormGroup>
      </Col>
      {error !== undefined && (
        <Col md={12} className="d-flex justify-content-end">
          <span className="text-danger">{error}</span>
        </Col>
      )}
      <Col className="d-flex justify-content-end mt-3">
        <Button isLoading={loading} onInvoked={() => saveComponent()}>
          <Icon icon="save" color="#fff" />
          <span className="ms-2">Save</span>
        </Button>
      </Col>
    </Row>
  );
};

CreateCharacteristicModal.propTypes = {
  onItemCreated: PropTypes.func.isRequired,
  cityId: PropTypes.number.isRequired,
  dynastyId: PropTypes.number.isRequired,
};

CreateCharacteristicModal.defaultProps = {

};

export default CreateCharacteristicModal;
